export const featureAccess = {
  // Free plan features
  // onlineOrderingPage: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],
  // unlimitedOrders: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],
  // collectionOrders: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],
  // cashOrders: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],
  // menuManagement: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],
  // discountsVouchers: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],
  // customerListExport: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],
  // orderNotifications: ['Free', 'Starter', 'Growth', 'Pro', 'Enterprise'],

  // Starter plan features (includes everything from free)
  // brandedOrderingWebsite: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  customDomain: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  // secureHosting: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  // businessAdminApp: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  apiAccess: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  deliveryOrders: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  onlinePayments: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  // freeSetupMenuUpload: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  qrCodeOrdering: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  loyaltyPointsSystem: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  // customerOrderHistory: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  seoOptimization: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  googleMapsOptimization: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  brandedOrderEmails: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  salesReports: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  customerDatabase: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  unlimitedStaffLogins: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  dailyPayouts: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  telephoneEmailSupport: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  singleLocation: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  staffactivitylogs: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  businessPayments: ['Starter', 'Growth', 'Pro', 'Enterprise'],
  // fullWebsiteCustomization: ['Starter', 'Growth', 'Pro', 'Enterprise'],

  // Growth plan features (includes everything from starter)
  googleReviewsBooster: ['Growth', 'Pro', 'Enterprise'],
  
  emailSmsMarketing: ['Growth', 'Pro', 'Enterprise'],
  socialMediaScheduler: ['Growth', 'Pro', 'Enterprise'],
  brandedBusinessEmail: ['Growth', 'Pro', 'Enterprise'],
  instantPayouts: ['Growth', 'Pro', 'Enterprise'],
  advancedSalesReports: ['Growth', 'Pro', 'Enterprise'],
  customerSegmentation: ['Growth', 'Pro', 'Enterprise'],
  // multiUserAccess: ['Growth', 'Pro', 'Enterprise'],
  twoLocations: ['Growth', 'Pro', 'Enterprise'],

  // Pro plan features (includes everything from growth)
  brandedCustomerApp: ['Pro', 'Enterprise'],
  brandedRiderApp: ['Pro', 'Enterprise'],
  // advancedLoyaltyProgram: ['Pro', 'Enterprise'],
  // pushNotifications: ['Pro', 'Enterprise'],
  fullWebsiteCustomization: ['Pro', 'Enterprise'],
  // seoManagement: ['Pro', 'Enterprise'],
  unlimitedStaffAccounts: ['Pro', 'Enterprise'],
  marketingDashboard: ['Pro', 'Enterprise'],
  advancedAnalytics: ['Pro', 'Enterprise'],
  orderRouting: ['Pro', 'Enterprise'],
  fiveLocations: ['Pro', 'Enterprise'],
  smsmarketing: ['Growth', 'Pro', 'Enterprise'],

  // Enterprise plan features (includes everything from pro)
  multilocations: ['Enterprise'],
  centralizedAdminPortal: ['Enterprise'],
  advancedCRM: ['Enterprise'],
  // multiLocationLoyalty: ['Enterprise'],
  franchiseTools: ['Enterprise'],
  customIntegrations: ['Enterprise'],
  whiteLabelOptions: ['Enterprise'],
  dedicatedAccountManager: ['Enterprise'],
  prioritySupport: ['Enterprise'],
};

// Plan definitions for reference
export const plans = {
  Free: {
    name: 'Free',
    price: '£0/month',
    description: 'For restaurants starting online.',
    features: [
      'Online Ordering Page (subdomain: yourbrand.getmefood.co.uk) with Get Me Food branding visible',
      'Unlimited Orders',
      'Collection Orders only (no delivery)',
      'Cash Orders only (no online payments)',
      'Menu Management (items, photos, options)',
      'Discounts & Vouchers',
      'Customer List Export',
      'Order Notifications (web & email)'
    ]
  },
  Starter: {
    name: 'Starter',
    price: '£39/month',
    specialOffer: '£19/month OR £190 Per Year Paid Upfront',
    description: 'For independents wanting a professional online presence.',
    features: [
      'Full Branded Ordering Website (e.g. www.mytakeaway.co.uk)',
      'Free Custom Domain + Annual Renewal included',
      'Secure Hosting included',
      'Business Admin App (manage orders & settings)',
      'API Access (connect to EPOS/other software)',
      'Online Ordering (Collection + Delivery Orders)',
      'Online Payments at 1% flat',
      'Unlimited Orders',
      'Menu Management (photos, options, categories)',
      'Free Setup & Menu Upload (by our team)',
      'QR Code Ordering (table & takeaway QR menus)',
      'Vouchers, Discounts & Promo Codes',
      'Basic Loyalty Points System',
      'Customer Order History for repeat ordering',
      'SEO-Friendly Website + Basic SEO Optimisation',
      'Google Maps & Search Optimisation',
      'Order Notifications (web + email)',
      'Branded Order Confirmation Emails',
      'Daily/Weekly Sales Reports + Basic Dashboard Analytics',
      'Customer Database (basic export)',
      'Unlimited Staff Logins (basic access)',
      'Daily Payouts Option',
      'Telephone & Email Support (business hours)',
      '1 Location included'
    ]
  },
  Growth: {
    name: 'Growth',
    price: '£49/month',
    specialOffer: '£29/month OR £290 Per Year Paid Upfront',
    description: 'For restaurants ready to grow with marketing & repeat business.',
    features: [
      'Google Reviews Booster (auto-review requests)',
      'Email & SMS Marketing Suite (campaigns + templates)',
      'Social Media Scheduler + Content Templates',
      'Branded Business Email (1 included)',
      'Free Custom Domain',
      'Instant Payouts Option',
      'Advanced Sales Reports (item trends, peak hours, repeat customers)',
      'Customer Database with Segmentation (filter by spend, order history)',
      'Multi-user Access (manager + staff logins)',
      'Up to 2 Locations included (+£15/month per additional location)'
    ]
  },
  Pro: {
    name: 'Pro',
    price: '£69/month',
    specialOffer: '£39/month OR £390 Per Year Paid Upfront',
    description: 'For serious restaurants who want branded apps & advanced marketing.',
    features: [
      'Branded Customer Mobile App (iOS & Android)',
      'Branded Rider/Delivery App',
      'Advanced Loyalty & Rewards Program (points, cashback, tiers)',
      'Push Notifications (direct to app users)',
      'Full Website Customisation (layouts, banners, custom branding)',
      'SEO Management + Monthly Performance Reports',
      'Unlimited Staff Accounts + Activity Logs',
      'Marketing Dashboard (ROI, conversions, repeat vs new customers)',
      'Advanced Analytics (basket size, churn risk, LTV tracking)',
      'Order Routing for Multi-Location Delivery',
      'Up to 5 Locations included (+£10/month per additional location)'
    ]
  },
  Enterprise: {
    name: 'Enterprise',
    price: 'Custom Pricing',
    description: 'For large chains & franchises.',
    features: [
      'Unlimited Locations (grouped billing)',
      'Centralised Admin Portal (HQ control)',
      'Advanced CRM (customer lifetime value, retention, churn analysis)',
      'Multi-location Loyalty Program (shared points across outlets)',
      'Franchise/Franchisee Tools (reporting by store)',
      'API Access & Custom Integrations (POS, delivery, kiosk, loyalty cards)',
      'White-Label Apps & Website Options (no "Get Me Food" branding)',
      'Dedicated Account Manager',
      'Priority Support (24/7 phone + dedicated WhatsApp group)'
    ]
  }
};
